import { Route, Routes } from 'react-router-dom'
import { PageTitle } from '../../../../_metronic/layout/core'
import { useT } from '_metronic/i18n/Metronici18n'
import { TermosListWrapper } from './termos-list/TermosList'

const TermosPage = () => {
  const { t } = useT()

  return (
    <Routes>
      <Route
        path=''
        element={
          <>
            <PageTitle description={t('pagina.termos.descricao')}>{t('menu.termos')}</PageTitle>
            <TermosListWrapper />
          </>
        }
      />
    </Routes>
  )
}

export default TermosPage
